import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SidebarNav from '../../components/common/SidebarNav';
import { useOnClickOutside } from '../../helpers/helperFunctions';
import { AppWrap } from '../../styles/stylesStyled';

import {
  MY_TEAM,
  SETTINGS_ACCOUNT,
  SETTINGS_NOTIFICATIONS,
  SETTINGS_PAYMENTS,
  SETTINGS_SECURITY,
  SETTINGS_TEAM_SETTINGS
} from '../../routes/routes';
import { Layout, LayoutContentWrapper, Main } from './BackofficeLayoutStyled';
import { Footer } from './common/Footer';

export const BackofficeLayout = ({ children }: any) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const pathname = useLocation().pathname;

  const ref = useRef();
  useOnClickOutside(ref, () => menuIsOpen && setMenuIsOpen(false));

  return (
    <Layout>
      <LayoutContentWrapper>
        <SidebarNav open={sidebar} onClose={setSidebar} />
        <AppWrap>{children}</AppWrap>
        {pathname !== MY_TEAM && <Footer />}
      </LayoutContentWrapper>
      {/* <ZendeskWidget /> */}
    </Layout>
  );
};
